module.exports = __webpack_public_path__ + "static/gallery-img-18-b05e9f211a8d46ad2fd08e47d8c14174.jpg";